import { Client, Request } from "@henrotaym/api-client";
import { TrustupProCredential } from ".";
import setup from "../../setup";
import { AuthenticatedUser } from "./models";

/**
 * Representing available trustup pro auth related actions.
 */
class TrustupProAuth
{
    /**
     * Setting up underlying client.
     */
    constructor()
    {
        /**
         * Underlying client
         * @type {Client}
         */
        this.client = new Client(new TrustupProCredential);
    }

    /**
     * Getting authenticated user or redirect response.
     */
    async getAuthenticatedUserOrRedirectResponse()
    {
        const response = await this.getUserRequestResponse();

        if (response.ok()) {
            return this.formatUserResponse(response.get());
        }
        
        // If not having body return null.
        if (!response.get()) {
            return null;
        }

        /** @type {import("./types").AuthenticatedUserResponseRedirectType[]} */
        const types = ['app_account_cancelled', 'app_not_installed'];

        // if body is a redirect response, return body.
        if (response.getResponse().isStatus(403)
            && types.includes(response.get().type)
        ) {
            return response.get();
        }
        
        return null;
    }

    /**
     * Getting authenticated user or null otherwise.
     */
    async getAuthenticatedUser()
    {
        const response = await this.getUserRequestResponse();

        if (!response.ok()) {
            return null
        }

        return this.formatUserResponse(response.get());
    }

    /**
     * Transforming user raw data to user model.
     * @param {import("./types").RawAuthenticatedUserResponseInterface} response
     * @returns {import("./types").AuthenticatedUserResponseInterface}
     */
    formatUserResponse(response)
    {
        return {
            ...response,
            user: new AuthenticatedUser(response.user)
        }
    }

    /** 
     * Getting user request response.
     * @private
     */
    getUserRequestResponse()
    {
        /** @type {Request<import("./types").AuthenticatedUserResponses>} */
        const request = new Request;
        request.setVerb('GET')
            .setUrl('user')
            .addQuery({ app: setup.current_app_key });

        return this.client.try(request);
    }
}

export default TrustupProAuth;